import React from 'react';
import { useIntl } from 'react-intl';

import { colors } from '@fhs/ui/src/tokens/colors';
import { HStack, IconButton, ToggleButtonGroup, VStack } from '@fhs-legacy/universal-components';
import { InlineAlert } from '@fhs-legacy/universal-components';
import Picture from 'components/picture';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { StyledDonationCard, StyledDonationSubTitle, StyledDonationTitle } from './styled';
import { IDonationAtCheckoutWithContentProps } from './types';

const DonationAtCheckout: React.FC<
  React.PropsWithChildren<IDonationAtCheckoutWithContentProps>
> = ({
  header,
  subtitle,
  donationOptions,
  logo,
  isContinueBlocked,
  selectedDonationId,
  onChangeValue,
  onInfoPressed,
}) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <StyledDonationTitle color={isContinueBlocked ? colors.$error : ''}>
        {header}
        {'\u00A0'}
        <IconButton
          onPress={onInfoPressed}
          variant="ghost"
          iconName="info"
          size="xs"
          alignSelf="flex-end"
          padding="$0"
          {...hiddenAccessibilityPlatformProps}
        />
      </StyledDonationTitle>
      <StyledDonationCard
        color={isContinueBlocked ? colors.$error : ''}
        borderColor={isContinueBlocked ? colors.$error : ''}
        borderWidth={isContinueBlocked ? 1 : ''}
      >
        <HStack space="$2" alignItems="center">
          {logo && (
            <Picture width="64px" height="64px" image={logo} alt={header} objectFitContain />
          )}
          <VStack width="full" maxWidth="80%" paddingX="$2">
            <StyledDonationSubTitle color={isContinueBlocked ? colors.$error : ''}>
              {subtitle}
            </StyledDonationSubTitle>
          </VStack>
        </HStack>
        <ToggleButtonGroup
          _toggleButton={{
            minWidth: 75.5,
            maxWidth: 213,
            borderRadius: 100,
          }}
          options={donationOptions}
          onChangeValue={onChangeValue}
          value={selectedDonationId}
          accessibilityHint={formatMessage({ id: 'selectDonationAmount' })}
          accessibilityLabel={formatMessage({ id: 'selectDonationAmount' })}
          style={{
            paddingVertical: 10,
            gap: 8,
            justifyContent: 'center',
          }}
        />
      </StyledDonationCard>
      {isContinueBlocked && (
        <InlineAlert
          status="error"
          borderRadius={8}
          marginBottom="$2"
          message={formatMessage({
            id: 'selectDonationMissing',
          })}
        />
      )}
    </>
  );
};

export default DonationAtCheckout;
